import {ChangeDetectorRef, OnDestroy, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@aztrix/translate';
import {AlistItemRepresentation} from '@aztrix/sdk';
import {ControlsOf, ValuesOf} from '@ngneat/reactive-forms';
import {Observable, Subscription} from 'rxjs';
import {itemLabel$} from '@aztrix/helpers';

@Pipe({name: 'itemLabel', pure: false})
export class ItemLabelPipe implements PipeTransform, OnDestroy {
  private _value?: AlistItemRepresentation;
  private _latestValue?: string;
  private _latestReturnedValue?: string;

  private _subscription = new Subscription();

  constructor(
    private _translate: TranslateService,
    private _changeDetector: ChangeDetectorRef
  ) {}

  transform(
    value: AlistItemRepresentation | ValuesOf<ControlsOf<AlistItemRepresentation>>
  ): string | undefined {
    if (!this._value) {
      this._value = <AlistItemRepresentation>value;

      this._subscribe(itemLabel$(this._translate, <AlistItemRepresentation>value));

      this._latestReturnedValue = this._latestValue;
      return this._latestValue;
    }

    if (value !== this._value) {
      this._dispose();
      return this.transform(value);
    }

    if (this._latestValue === this._latestReturnedValue) {
      return this._latestReturnedValue;
    }

    this._latestReturnedValue = this._latestValue;
    return this._latestValue;
  }

  ngOnDestroy() {
    this._dispose();
  }

  private _subscribe(obs: Observable<any>): void {
    this._subscription.add(
      obs.subscribe((value) => {
        this._latestValue = value;
        this._changeDetector.markForCheck();
      })
    );
  }

  private _dispose() {
    this._subscription.unsubscribe();
    this._value = undefined;
    this._latestValue = undefined;
    this._latestReturnedValue = undefined;
  }
}
